import { Link, useLocation, Location } from "react-router-dom";
import { UserOutlined } from "@ant-design/icons";
import ROUTES from "../../../configs/routesConfig";
import { memo, useMemo } from "react";

type ProfileLinkProps = {
  user?: any;
};

const ProfileLink = memo(({ user }: ProfileLinkProps) => {
  const location: Location = useLocation();

  const className = useMemo(
    () =>
      `align-center desktop-btn d-flex header-button py-0 px-4 ${
        location.pathname === ROUTES.PROFILE ? "active" : ""
      }`,
    [location.pathname],
  );

  return (
    <Link className={className} to={ROUTES.PROFILE} id={ROUTES.PROFILE}>
      <UserOutlined />
      {user && (
        <span className="user-header-label elipsis ml-2">{`${user.firstName} ${user.lastName}`}</span>
      )}
    </Link>
  );
});

export default ProfileLink;
